import { useStore } from 'zustand/react';
import { useContext } from 'react';

import { type SearchStore, type SearchStoreApi, SearchStoreContext } from './SearchStoreProvider';

export const useSearchStore = <T,>(selector: (store: SearchStore) => T): T => {
  const searchStoreContext = useContext(SearchStoreContext);

  if (!searchStoreContext) {
    throw new Error(`useSearchStore must be used within SearchStoreProvider`);
  }

  return useStore(searchStoreContext, selector);
};

export const useSearchStoreContext = (): SearchStoreApi => {
  const searchStoreContext = useContext(SearchStoreContext);

  if (!searchStoreContext) {
    throw new Error(`useSearchStore must be used within SearchStoreProvider`);
  }

  return searchStoreContext;
};
